import Svg, {Path} from 'react-native-svg'

import {COOEY_MARK_PATH} from '#/lib/cooey/mark'
import {type Props, useCommonSVGProps} from './common'
import {createSinglePathSVG} from './TEMPLATE'

// CooeyNet mark: a three-piece red triangle with a Y-shaped negative space.
// Filled with the current color, so it inherits the cooey-red theme.
export const Mark = createSinglePathSVG({
  path: COOEY_MARK_PATH,
})

export function Full(
  props: Omit<Props, 'fill' | 'size' | 'height'> & {
    markFill?: Props['fill']
    textFill?: Props['fill']
  },
) {
  // Cooey: the "full" logo is just the CooeyNet mark (no wordmark).
  const {fill, size, style, gradient, ...rest} = useCommonSVGProps(props)

  return (
    <Svg
      fill="none"
      {...rest}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      style={[style]}>
      {gradient}
      <Path fill={props.markFill ?? fill} d={COOEY_MARK_PATH} />
    </Svg>
  )
}
